var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionStatusCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-subscription-status-cancelled"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription-status-cancelled",
    clipPath: "url(#clip-subscription-status-cancelled)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22072",
    "data-name": "Group 22072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cancel",
    d: "M16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Zm0,2.632A7.337,7.337,0,0,1,20.135,9.9L9.9,20.134A7.368,7.368,0,0,1,16,8.632Zm0,14.737A7.337,7.337,0,0,1,11.865,22.1L22.1,11.866a7.368,7.368,0,0,1-6.1,11.5Z",
    transform: "translate(-6 -6)",
    fill: "#f44336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionStatusCancelled);
export default __webpack_public_path__ + "static/media/subscription-status-cancelled.2c4bb8273d57cad1d984335b947a06e1.svg";
export { ForwardRef as ReactComponent };